import {
  isElementOnScreen,
  sendGoogleEvent,
  getBreakpointMinWidth, sendAmplitudeEvent,
} from '@html/_common/utils';

export default class AoTourStickyBar {
  constructor(eventCategory, selectors, goToFunc) {
    this.eventCategory = eventCategory;
    this.selectors = selectors || [];
    this.goTo = goToFunc;
    this.priceBlockSelectorDesktop = '.ao-tour-above-fold-desktop .ao-tour-above-fold__main .js-ao-tour-above-fold__price-block';
    this.priceBlockSelectorMobile = '.ao-tour-above-fold-mobile .ao-tour-above-fold__main .js-ao-tour-above-fold__price-block';
    this.firstLoad = true;

    this.HID_CLASS = 'ao-tour-sticky-bar--hidden';
  }

  init() {
    this.scrollHandler();
    this.ratingHandler();
    this.availabilityCTAHandler();
    this.trackingHandler();
  }

  scrollHandler() {
    const isMobile = $(window).width() < getBreakpointMinWidth('m2');
    const $priceContainer = $('.js-ao-tour-above-fold__price-container');
    const priceIsZero = !$priceContainer?.text()?.length;

    if ($priceContainer && isMobile && !priceIsZero) $(document).trigger('stickyBar:visibilityChange', true);

    $(document).on('scroll ready stickyBar:refresh', () => {
      const $stickyBar = $('.js-ao-tour-sticky-bar');
      let isVisible;

      if (!($priceContainer && isMobile)) {
        isVisible = this.getPriceBlockVisible() || this.getIsAvailabilityVisible() || this.getIsFooterVisible();
      } else {
        this.firstLoad = false;
        isVisible = priceIsZero
            || this.getPriceBlockVisible()
            || this.getIsAvailabilityVisible()
            || this.getIsFooterVisible();
      }

      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      if (isVisible) {
        if ($stickyBar.hasClass(this.HID_CLASS)) return;

        $stickyBar.addClass(this.HID_CLASS);
        $(document).trigger('stickyBar:visibilityChange', false);
        return;
      }

      if (!$stickyBar.hasClass(this.HID_CLASS)) return;

      $stickyBar.removeClass(this.HID_CLASS);
      $(document).trigger('stickyBar:visibilityChange', true);
    });
  }

  trackingHandler() {
    const $stickyButtons = $('.js-ao-tour-sticky-bar__button');
    $stickyButtons.on('click', (e) => {
      let eventText = $(e.currentTarget).text().trim();
      if ($(e.currentTarget).hasClass('js-ao-tour-sticky-bar__secondary-cta--book-online')) {
        eventText = 'Book online';
      }

      sendGoogleEvent(
        this.eventCategory,
        'Sticky bar Button - Click',
        eventText,
        {
          ampEventName: eventText.includes('Availability') ? 'section_viewed_tdp_availability' : undefined,
          disableScrollEvent: true,
        },
      );
    });

    // Intent event for measuring A/B test results
    const $intentButton = $('.js-ao-tour__availability-intent');
    $intentButton.on('click', (e) => {
      sendAmplitudeEvent({
        ampEventName: 'tdp_availability_button_clicked',
        click_source: 'cta_bar',
      });
      sendGoogleEvent(
        this.eventCategory,
        'Check Availability Intent',
        $(e.currentTarget).data('label'),
        {
          ampEventName: 'tdp_availability_button_clicked',
          tdp_availability_button_clicked_element: 'Sticky Bar',
        },
      );
    });
  }

  ratingHandler() {
    $('.js-ao-tour-sticky-bar__rating').on('click', () => {
      const reviewsAvailable = $('.js-ao-tour-sticky-bar').data('reviews');
      const gaEventLabel = 'Sticky Bar Click';
      if (reviewsAvailable === 'tour') {
        this.goTo('reviews', 'Reviews', gaEventLabel);
      } else if (reviewsAvailable === 'operator') {
        this.goTo('operator', 'Operator', gaEventLabel);
      }
    });
  }

  availabilityCTAHandler() {
    const $checkAvailabilityButtons = $('.js-ao-tour-sticky-bar__main-cta--availability, .js-ao-tour-sticky-bar__secondary-cta--book-online');
    if ($checkAvailabilityButtons.length > 0) {
      $checkAvailabilityButtons.on('click', (e) => {
        e.preventDefault();
        this.goTo('check', $(e.currentTarget).text());
        $(e.target).trigger('blur');
      });
    }
  }

  getIsAvailabilityVisible() {
    let index = -1;
    while (index < this.selectors.length) {
      index += 1;
      if (isElementOnScreen(this.selectors[index])) {
        return true;
      }
    }
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  getPriceBlockVisible() {
    return (isElementOnScreen(this.priceBlockSelectorDesktop) && $('.ao-tour-above-fold-desktop').css('display') !== 'none')
      || (isElementOnScreen(this.priceBlockSelectorMobile) && $('.ao-tour-above-fold-mobile').css('display') !== 'none');
  }

  // eslint-disable-next-line class-methods-use-this
  getIsFooterVisible() {
    return isElementOnScreen($('.footer__reviews-area')) || isElementOnScreen($('.footer__site-externals-area'));
  }
}
